import { render, staticRenderFns } from "./MakeAssociationsInterface.vue?vue&type=template&id=232e2f14"
import script from "./MakeAssociationsInterface.vue?vue&type=script&lang=js"
export * from "./MakeAssociationsInterface.vue?vue&type=script&lang=js"
import style0 from "./MakeAssociationsInterface.vue?vue&type=style&index=0&id=232e2f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
